import { Message, MessageResponse } from "services/types/messages.type";
import { StaffMember } from "../services/types/staff.type";
import { formatStaffMemberFullName } from "./common";
import { formatPatient } from "./patients.util";
import userPhotoFallback from "assets/images/user.png";

export const formatMessage = (message: MessageResponse): Message => {
  return {
    ...message,
    patient: message.patient && formatPatient(message.patient),
    assignee: message.assignee && {
      ...(formatStaffMemberFullName(message.assignee) as StaffMember),
      avatar: message.assignee.photo ?? userPhotoFallback,
    },
    sender: message.sender && {
      ...formatStaffMemberFullName(message.sender as StaffMember),
      avatar: message.sender.photo ?? userPhotoFallback,
    },
    media: message.media,
  };
};
